import { ApolloCache, Reference } from "@apollo/client"
import { ADMIN_FRAGMENT } from "../fragment/admin"

export const updateCacheAdmin = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      users(existing = []) {
        const newAdminRef = cache.writeFragment({
          data: entryData,
          fragment: ADMIN_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newAdminRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) => el?.__ref !== newAdminRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) => el?.__ref !== newAdminRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newAdminRef
            }
            return items
        }
      },
      aggregateUser(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
